import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'VIconButton',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { disabled?: boolean }





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["v-icon-button", { disabled: props.disabled }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})